import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('RadioButton');

const propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.node,
    description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    checked: PropTypes.bool,
    className: PropTypes.string,
    hasError: PropTypes.bool,
    showError: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    verticalCenter: PropTypes.bool,
    additionalLabel: PropTypes.node,
    notification: PropTypes.node,
    onChange: PropTypes.func,
};

const defaultValues = {
    checked: false,
    hasError: false,
    showError: false,
    disabled: false,
    verticalCenter: false,
    additionalLabel: null,
};

function RadioButton(props) {
    const {
        additionalLabel,
        children,
        className,
        description,
        disabled,
        hasError,
        id,
        img = null,
        label,
        labelClass = null,
        notification = null,
        showError,
        value,
        verticalCenter,
        ...rest
    } = props;
    const classname = showError && hasError ? `${className}--radioError` : className;

    const radioButtonElements = () => {
        const labelElements = (
            <>
                <label className={labelClass || bem('label')} htmlFor={id}>
                    {label}
                </label>
                {additionalLabel}
            </>
        );

        return (
            <>
                {label && (verticalCenter ? <div className={bem('labels')}>{labelElements}</div> : labelElements)}
                {description && <span className={bem('description', { disabled, verticalCenter })}>{description}</span>}
                {typeof children === 'function' ? children(props) : children}
                {notification && <div className={bem('notification')}>{notification}</div>}
                {img && <div className={img} />}
            </>
        );
    };

    const inputElement = <input disabled={disabled} id={id} type="radio" {...rest} value={value} />;

    return (
        <div className={bem(null, null, [classname, verticalCenter && 'verticalCenter'])}>
            {verticalCenter ? <div className={bem('vertical-input')}>{inputElement}</div> : inputElement}
            {verticalCenter ? <div className={bem()}>{radioButtonElements()}</div> : radioButtonElements()}
        </div>
    );
}

RadioButton.propTypes = propTypes;
RadioButton.defaultValues = defaultValues;

export default RadioButton;
